import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { SecurityQuestionModel, SecurityQuestionSearchCriteria, SecurityQuestionTree } from '../../../../../models';
import { API_URL } from '../../../../../../services/config';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { CompartmentEndpoint } from '../../../compartment/constants/compartment-endpoint';
import { SecurityCheckContextType } from '../../../../../constants/security-check.constant';

@Injectable({
  providedIn: 'root',
})
export class SecurityCheckService {
  constructor(private http: WrapperHttpService) {}

  getSecurityQuestionsList({
    id,
    type,
    searchCriteria,
  }: {
    id: number;
    type: SecurityCheckContextType;
    searchCriteria: SecurityQuestionSearchCriteria;
  }): Observable<SecurityQuestionTree> {
    return this.http
      .withLoading()
      .get<SecurityQuestionTree>(
        `${API_URL}${HubEndpoint.SecurityQuestions}${
          type === SecurityCheckContextType.Hub ? HubEndpoint.Base : CompartmentEndpoint.Base
        }/${id}?${getQueryStringFromObject(searchCriteria)}`,
      );
  }

  addSecurityQuestion(
    id: number,
    body: SecurityQuestionModel,
    type: SecurityCheckContextType,
  ): Observable<SecurityQuestionModel> {
    return this.http
      .withLoading()
      .post<SecurityQuestionModel>(
        `${API_URL}${HubEndpoint.SecurityQuestions}${
          type === SecurityCheckContextType.Hub ? HubEndpoint.Base : CompartmentEndpoint.Base
        }/${id}`,
        body,
      );
  }

  updateSecurityQuestion(body: SecurityQuestionModel): Observable<SecurityQuestionModel> {
    return this.http.withLoading().post<SecurityQuestionModel>(`${API_URL}${HubEndpoint.SecurityQuestions}`, body);
  }

  deleteSecurityQuestion(questionId: number, contextType: SecurityCheckContextType): Observable<null> {
    return this.http
      .withLoading()
      .delete<null>(
        `${API_URL}${HubEndpoint.SecurityQuestions}${
          contextType === SecurityCheckContextType.Hub ? HubEndpoint.Base : CompartmentEndpoint.Base
        }/${questionId}`,
      );
  }

  saveQuestionsPosition(questions: number[]): Observable<void> {
    const url = `${API_URL}${HubEndpoint.SecurityQuestions}${HubEndpoint.Positions}`;
    const requestBody = {
      ids: questions,
    };

    return this.http.post(url, requestBody);
  }
}
